<div class="sc-simple-date-picker" [class.readonly]="readonly">
    <label
        *ngIf="!!label"
        [attr.for]="!readonly ? 'date-picker_' + formControlName : null">{{ label }}</label>
    <div class="sc-simple-date-picker__input-wrapper">
        <input
            id="date-picker_{{formControlName}}"
            type="text"
            bsDatepicker
            [bsValue]="dateFormControl.value"
            [formControl]="dateFormControl"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [bsConfig]="datePickerConfig"
            (bsValueChange)="handleValueChange($event)"
        >
        <sc-icon class="icon" icon="calendar"></sc-icon>
    </div>
</div>